import React, { Component } from "react";
import axios from "axios";

import { ButtonItem, SegmentedItem, TableItemDinamico, dineroDisabledMask } from "../../../Components/Items";
import { Tooltip, message, PageHeader, Tag, Popconfirm } from "antd";
import { connect } from "react-redux";
import { BookFilled, CloseCircleOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import moment from "moment";
import MandarCorreoComplemento from "../CuentasPorCobrar/MandarCorreoComplemento/MandarCorreoComplemento";
import MandarCorreoPago from "../CuentasPorCobrar/MandarCorreoPago/MandarCorreoPago";
import VerPagosRelacionadosAP from "./VerPagosRelacionadosAP/VerPagosRelacionadosAP";
//import MandarCorreoPagos from "./MandarCorreoPagos/MandarCorreoPagos";

class AbonosProveedores extends Component {
    tableRef = null;
    state = {
        todasAbonosC: [],
        loading: false,
        totalRecords: 0,
        valor: 0,
        modalVerComplemento: false,
        modalVerComplementoId: null,
        modalVerPago: false,
        modalVerPagoId: null,
    }

    consultarPagos = (params) => {
        this.setState({ loading: true });

        axios
            .post(
                "abonosProveedores/selectPagosAbonosProveedores",
                { empresaId: this.props.empresaId, ...params },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasAbonosC:
                            res.data.data.map(value => {
                                return {
                                    ...value,
                                    folio: value.complemento ? ((value.complementoSerie || "") + " - " + (value.complementoNumero || "")) : ((value.pagoSerie || "") + " - " + (value.pagoNumero || "")),
                                    fechaNota: value.fechaNota ? value.fechaNota : value.createdAt,
                                    accion: {
                                        _id: value._id,
                                        estado: value.estado,
                                        complemento: value.complemento,
                                        jsonPago: value.jsonPago,
                                        jsonComplemento: value.jsonComplemento,
                                        estadoAbono: value.estadoAbono,
                                        totalPagadoAbono: value.totalPagadoAbono,
                                        creditoId: value.creditoId
                                    },
                                }
                            }),
                        totalRecords: res.data.totalRecords || 0,
                        loading: false
                    });
                } else {
                    this.setState({ todasAbonosC: [], loading: false, totalRecords: 0 });
                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                message.error("Error al consultar los Pagos");
                console.log(err);
            });
    }

    handleCancelarPago = (id) => {
        this.setState({ loading: true });
        axios.post("pagos/cancelarPago", { pagoId: id, empresaId: this.props.empresaId }, { headers: this.props.headersToken }).then(res => {
            if (res.data.success === 2) {
                message.success("Pago cancelado correctamente");
                if (this.tableRef) {
                    this.tableRef.fetchData();
                }
            } else {
                message.error("Error al cancelar el Pago");
            }
            this.setState({ loading: false });
        }).catch(err => {
            message.error("Error al cancelar el Pago");
            console.log(err);
            this.setState({ loading: false });
        });
    }


    enviarPagos(value) {
        this.setState({ modalVerPago: true, modalVerPagoId: value });
    }
    enviarComplemento(value) {
        this.setState({ modalVerComplemento: true, modalVerComplementoId: value });
    }
    cerrarVerComplemento() {
        this.setState({
            modalVerComplemento: false,
            modalVerComplementoId: null,
        });
    }
    cerrarMandarCorreoPago() {
        this.setState({
            modalVerPago: false,
            modalVerPagoId: null,
        });
    }

    agregarAbonoProveedor() {
        this.props.history.push("/panel/agregarAbonoProveedor");
    }

    editarAbonoProveedor(id) {
        this.props.history.push("/panel/editarAbonoProveedor", { id });
    }

    cancelarAbonoProveedor(value) {
        axios
            .post(
                "abonosProveedores/cancelarAbonoProveedor",
                { abonoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Abono proveedor cancelado");
                } else {
                    message.error(res.data.message || "Sucedio un error y no se pudo cancelar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    verPagosRelacionados(id) {
        this.setState({
            modalVerPagosRelacionados: true,
            modalVerPagosRelacionadosId: id,
        });
    }
    cerrarPagosRelacionados() {
        this.setState({
            modalVerPagosRelacionados: false,
            modalVerPagosRelacionadosId: null,
        });
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
    }

    render() {
        const columns = [
            {
                title: "Folio",
                dataIndex: "folio",
                key: "folio",
                render: (value, record) => (record.pagoSerie || "") + " - " + (record.pagoNumero || ""),
                width: 100,
            },

            {
                title: "Proveedor",
                dataIndex: "proveedor",
                key: "proveedor",
                width: 100,
                buscar: 'proveedor',
                ellipsis: true,
            },
            {
                title: "Fecha",
                dataIndex: "fechaPago",
                key: "fechaPago",
                sorter: true,
                render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm"),
                width: 100,
                ellipsis: true,
                align: "center",
            },
            {
                title: "Forma de Pago",
                dataIndex: "formaDePago",
                key: "formaDePago",
                align: "center",
                width: 80,
                ellipsis: true,
            },
            {
                title: "Moneda",
                dataIndex: "moneda",
                key: "moneda",
                buscar: "moneda",
                responsive: [],
                width: 0,
            },
            {
                title: "Monto",
                dataIndex: "monto",
                key: "monto",
                sorter: true,
                render: (_, record) => (
                    <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                        <span>{dineroDisabledMask(record.monto)}</span>
                        {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                    </div>
                ),
                buscar: "monto",
                width: 100,
                ellipsis: true,
                align: "right",
            },

            {
                title: "Total Aplicado",
                dataIndex: "totalPagadoAbono",
                key: "totalPagadoAbono",
                sorter: true,
                render: (_, record) => (
                    <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                        <span>{dineroDisabledMask(record.totalPagadoAbono || 0)}</span>
                        {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                    </div>
                ),
                buscar: "totalPagadoAbono",
                width: 100,
                ellipsis: true,
                align: "right",
            },

            {
                title: "Saldo Pendiente",
                dataIndex: "saldoPendienteAbono",
                key: "saldoPendienteAbono",
                render: (_, record) => (
                    <div style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                        <span>{dineroDisabledMask(record.saldoPendienteAbono || (record.monto - (record.totalPagadoAbono || 0)))}</span>
                        {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                    </div>
                ),
                width: 100,
                ellipsis: true,
                align: "right",
            },

            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                render: (value, record) => {
                    if (value === 0) {
                        return <Tag color="red" className="square-tag">Cancelado</Tag>;
                    }
                    if (value === 1) {
                        return <Tag color="green" className="square-tag">Vigente</Tag>;
                    }

                },
                width: window.innerWidth > 1200 ? 110 : 160,
                ellipsis: true,
                align: "center",
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                align: "center",
                width: window.innerWidth > 1200 ? 145 : 160,
                onHeaderCell: () => ({
                    style: { textAlign: 'center', padding: '4px' }
                }),
                onCell: () => ({
                    className: "acciones-sin-hover",
                    style: { textAlign: 'center', padding: '4px' }
                }),
                render: (value, _, index) => {
                    let buttons = [];

                    const puedeVerPago = value.jsonPago && !value.complemento && value.estado === 1;
                    buttons.push(
                        <Tooltip key={`ver-pago-${index}`} title={puedeVerPago ? "Ver PDF" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                lila
                                icon={<BookFilled />}
                                onClick={() => puedeVerPago && this.enviarPagos(value._id)}
                                disabled={!puedeVerPago}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    const puedeVerComplemento = value.complemento && value.jsonComplemento && value.estado === 1;
                    buttons.push(
                        <Tooltip key={`ver-complemento-${index}`} title={puedeVerComplemento ? "Ver PDF Complemento" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                naranja
                                icon={<BookFilled />}
                                onClick={() => puedeVerComplemento && this.enviarComplemento(value._id)}
                                disabled={!puedeVerComplemento}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    //Los abonos que nacieron de un credito comparten poliza con el:
                    //se editan y se cancelan desde el credito, no desde aqui
                    const esDeCredito = !!value.creditoId;

                    const puedeEditar = value.estadoAbono === 0 && value.estado === 1 && !esDeCredito;
                    buttons.push(
                        <Tooltip key={`editar-${index}`} title={puedeEditar ? "Editar" : (esDeCredito ? "Este abono lo generó un crédito" : "No disponible")} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                cyan
                                icon={<EditOutlined />}
                                onClick={() => puedeEditar && this.editarAbonoProveedor(value._id)}
                                disabled={!puedeEditar}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    const puedeVerVentas = value.estadoAbono !== 0 && value.estado === 1;
                    buttons.push(
                        <Tooltip key={`ver-ventas-${index}`} title={puedeVerVentas ? "Ver Ventas Relacionadas" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                azul
                                icon={<EyeOutlined />}
                                onClick={() => puedeVerVentas && this.verPagosRelacionados(value._id)}
                                disabled={!puedeVerVentas}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    const puedeCancelar = value.estadoAbono === 0 && value.estado === 1 && !esDeCredito;
                    if (puedeCancelar) {
                        buttons.push(
                            <Popconfirm
                                key={`cancelar-${index}`}
                                title="¿Seguro que quieres cancelar este abono proveedor?"
                                onConfirm={() => this.cancelarAbonoProveedor(value._id)}
                                okText="Sí"
                                cancelText="No"
                                okButtonProps={{ danger: true }}
                            >
                                <Tooltip title="Cancelar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        rojo
                                        icon={<CloseCircleOutlined />}
                                        

                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    } else {
                        buttons.push(
                            <Tooltip key={`cancelar-disabled-${index}`} title="No disponible" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    rojo2
                                    icon={<CloseCircleOutlined />}
                                    disabled={true}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];
        return (
            <>
                <PageHeader
                    title="Abonos Proveedores"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[{ label: 'Todos', value: 0 }, { label: 'Vigentes', value: 1 }, { label: 'Canceladas', value: 2 }]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({ valor: value });
                                        }
                                        this.setState({ valor: value });
                                    }}

                                    value={this.state.valor}
                                />
                            }
                            <ButtonItem
                                type="primary"
                                key="agregarAbonoProveedor"
                                olivo
                                onClick={this.agregarAbonoProveedor.bind(this)}
                                className="botonAgregar"
                            >
                                Agregar Abono Proveedor
                            </ButtonItem>
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    /*onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                this.props.history.push("/panel/verPagos", { id: record._id });
                            },
                        };
                    }}*/
                    anadirValorFiltro={this.state.valor}
                    onFetchData={this.consultarPagos.bind(this)}
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.todasAbonosC}
                    columns={columns}
                    filterStorageKey={"AbonosProveedoresFiltrosTabla" + this.props.empresaId}
                    pagination={false}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={0}
                />
                <MandarCorreoComplemento
                    visible={this.state.modalVerComplemento}
                    id={this.state.modalVerComplementoId}
                    cerrarMandarCorreoComplemento={this.cerrarVerComplemento.bind(this)}
                />
                <MandarCorreoPago
                    visible={this.state.modalVerPago}
                    id={this.state.modalVerPagoId}
                    cerrarMandarCorreoPago={this.cerrarMandarCorreoPago.bind(this)}
                />
                <VerPagosRelacionadosAP
                    visible={this.state.modalVerPagosRelacionados}
                    id={this.state.modalVerPagosRelacionadosId}
                    cerrarPagosRelacionados={this.cerrarPagosRelacionados.bind(this)}
                />
            </>
        );



    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoFacturaGlobal:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750916e798d4e0043687240"
            )?.activado,
    };
};

export default connect(mapStateToProps)(AbonosProveedores);